/**
 * Images live in Cloudflare R2, not in the bundle. The base URL is injected at
 * build time so the same code runs against a dev bucket or a CDN domain.
 */
const BASE = (import.meta.env['VITE_ASSET_BASE_URL'] ?? '').replace(/\/$/, '')

export function asset(path: string): string {
  const clean = path.replace(/^\//, '')
  return BASE ? `${BASE}/${clean}` : `/${clean}`
}
